import React, { useEffect, useState } from "react";
import MenuSection from "../../components/menu-section";
import { MenuItem } from "../../types";
import { useMenuHubApi } from "../../api/menuHub";
import champagnat from "../../assets/logo_champganhe.png"
import cajuru from "../../assets/logo_cajuru.png"

const Dashboard: React.FC = () => {
    const [menu, setMenu] = useState<MenuItem[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const { getPainels } = useMenuHubApi();

    useEffect(() => {
        const fetchMenu = async () => {
            try {
                const data = await getPainels();
                setMenu(Array.isArray(data?.solucoes) ? data?.solucoes : []);
            } catch (err) {
                console.error("Erro ao carregar o menu:", err);
                setMenu([]);
            } finally {
                setLoading(false);
            }
        };

        fetchMenu();
    }, []);

    const grouped = Array.isArray(menu)
        ? menu.reduce<Record<string, MenuItem[]>>((acc, item) => {
            if (!acc[item.titulo]) acc[item.titulo] = [];
            acc[item.titulo].push(item);
            return acc;
        }, {})
        : {};

    const colors: Record<string, Record<string, any>> = {
        "Hospital São Marcelino Champagnat": { headerColor: "#ED1C24", borderColor: "#FFB8BA", icon: <img src={champagnat} style={{ width: "52px", height: "32px" }}></img>, hover: "#FFF0F0", press: "#FFD2D2" },
        "Hospital Universitário Cajuru": { headerColor: "#4190C1", borderColor: "#4190C1", icon: <img src={cajuru} style={{ width: "32px", height: "32px" }}></img>, hover: "#F3FAFF", press: "#C1E3FB" },
        "Gestão Complexo Saúde": {
            headerColor: "#009535", borderColor: "#4AC762", icon: <div className="flex-center-row">
                <img src={champagnat} style={{ width: "52px", height: "32px" }}></img>
                <img src={cajuru} style={{ width: "32px", height: "32px", marginLeft: "1rem" }}></img>
            </div>, hover: "#F3FFF9", press: "#D4FFEA"
        },
    };

    if (loading) return <p>Carregando...</p>;

    if (!menu.length) return <p>Nenhum painel disponível.</p>;

    return (
        <main style={{ padding: "20px" }}>
            {Object.keys(grouped).map((titulo) => (
                <MenuSection
                    key={titulo}
                    titulo={titulo}
                    items={grouped[titulo]}
                    color={colors[titulo]?.headerColor || "#999"}
                    borderColor={colors[titulo]?.borderColor || "#999"}
                    icon={colors[titulo]?.icon}
                    hover={colors[titulo]?.hover}
                    press={colors[titulo]?.press}
                />
            ))}
        </main>
    );
};

export default Dashboard;
